export default __webpack_public_path__ + "static/media/compiegne16.aed2c175.jpg";